import React from 'react';
import { mcpServerUrl } from 'services/authService';
import { DATA_ACCESS_TEXT_STYLE, DataAccessText } from './dataAccessTypography';
import { CopyField, GuideStep } from './mcpGuideShared';
import mcpCodex01Settings from '../../assets/img/data-access/mcp-codex-01-settings.png';
import mcpCodex02Mcps from '../../assets/img/data-access/mcp-codex-02-mcps.png';
import mcpCodex03AddForm from '../../assets/img/data-access/mcp-codex-03-add-form.png';
import mcpCodex04Authenticate from '../../assets/img/data-access/mcp-codex-04-authenticate.png';
import mcpCodex05SignIn from '../../assets/img/data-access/mcp-codex-05-sign-in.png';
import mcpCodex07Chat from '../../assets/img/data-access/mcp-codex-07-chat.png';

const CodexMcpGuide: React.FC = () => (
  <div>
    <DataAccessText className="text-700 mb-4">
      Follow the steps below in OpenAI Codex. Codex signs you in with your Shiplab account, so no
      API token is required for this flow.
    </DataAccessText>

    <GuideStep
      step={1}
      title="Open Settings"
      imageSrc={mcpCodex01Settings}
      imageAlt="Codex Edit menu with Settings highlighted"
    >
      Open Codex Settings with <strong>[Ctrl+,]</strong>, or choose{' '}
      <strong>Edit → Settings…</strong> from the menu bar.
    </GuideStep>

    <GuideStep
      step={2}
      title="Open MCPs"
      imageSrc={mcpCodex02Mcps}
      imageAlt="Codex Plugins settings with the MCPs tab and Add server button"
    >
      In the sidebar, open <strong>Integrations → Plugins</strong>, then select the{' '}
      <strong>MCPs</strong> tab. Click <strong>+ Add server</strong>.
    </GuideStep>

    <GuideStep
      step={3}
      title="Enter the MCP server details"
      imageSrc={mcpCodex03AddForm}
      imageAlt="Connect to a custom MCP form with Streamable HTTP and Shiplab URL"
    >
      <p className="mb-3" style={DATA_ACCESS_TEXT_STYLE}>
        Choose a name for the server (for example <strong>Shiplab</strong>). Set the type to{' '}
        <strong>Streamable HTTP</strong>, paste the MCP server URL below, leave the header fields
        empty, then click <strong>Save</strong>.
      </p>
      <CopyField label="URL" value={mcpServerUrl} />
    </GuideStep>

    <GuideStep
      step={4}
      title="Authenticate"
      imageSrc={mcpCodex04Authenticate}
      imageAlt="Codex MCPs list showing shiplab with Authenticate button"
    >
      Back on the MCPs list, find your new server and click <strong>Authenticate</strong>.
    </GuideStep>

    <GuideStep
      step={5}
      title="Sign in to Shiplab"
      imageSrc={mcpCodex05SignIn}
      imageAlt="Shiplab sign-in form asking for username and password"
    >
      A browser window opens asking you to sign in with your Shiplab username and password. Use the
      same conectors you use for the Shiplab web app.
    </GuideStep>

    <GuideStep step={6} title="Confirm authentication">
      When you see <strong>Authentication complete. You may close this window.</strong>, close the
      browser tab and return to Codex. You are now linked to Shiplab.
    </GuideStep>

    <GuideStep
      step={7}
      title="Try it in a chat"
      imageSrc={mcpCodex07Chat}
      imageAlt="Codex chat showing Shiplab profile details after using the MCP server"
    >
      Start a conversation in Codex and ask about your Shiplab account, for example &quot;get my
      shiplab profile&quot;. Codex calls Shiplab on your behalf and returns live data without leaving
      the conversation.
    </GuideStep>
  </div>
);

export default CodexMcpGuide;
